import { SUPABASE_URL, SUPABASE_ANON_KEY, supabase } from './supabaseClient'

export async function invokeEdgeFunction(functionName, { body, accessToken } = {}) {
  const base = String(SUPABASE_URL || '').replace(/\/+$/g, '')
  const apikey = String(SUPABASE_ANON_KEY || '')
  const url = `${base}/functions/v1/${functionName}`
  const makeHeaders = (token) => {
    const h = {
      'Content-Type': 'application/json',
      apikey,
    }
    if (token) h.Authorization = `Bearer ${token}`
    return h
  }
  const doRequest = async (token) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: makeHeaders(token),
      body: JSON.stringify(body || {}),
    })
    const text = await res.text().catch(() => '')
    return { res, text }
  }

  const resolveToken = async () => {
    if (accessToken) return accessToken
    try {
      const { data } = await supabase.auth.getSession()
      return data?.session?.access_token || null
    } catch {
      return null
    }
  }

  const refreshToken = async () => {
    try {
      const { data, error } = await supabase.auth.refreshSession()
      if (error) return null
      return data?.session?.access_token || null
    } catch {
      return null
    }
  }

  let token = await resolveToken()
  let { res, text } = await doRequest(token)

  let data = null
  try {
    data = text ? JSON.parse(text) : null
  } catch {
    data = { raw: text }
  }
  if (!res.ok && res.status === 401) {
    const nextToken = await refreshToken()
    if (nextToken && nextToken !== token) {
      token = nextToken
      ;({ res, text } = await doRequest(token))
      data = null
      try {
        data = text ? JSON.parse(text) : null
      } catch {
        data = { raw: text }
      }
    }
  }

  if (!res.ok) {
    const msg = data?.error || data?.message || (text ? String(text) : '') || `HTTP ${res.status}`
    const err = new Error(msg)
    err.status = res.status
    err.data = data
    throw err
  }
  return data
}
